import React from 'react'

export default function HtmlIcon({cls}) {
    return (
        <svg
            className={cls + ''}
            xmlns="http://www.w3.org/2000/svg"
          
            enableBackground="new 0 0 512 512"
            viewBox="0 0 512 512"
        >
            <g xmlns="http://www.w3.org/2000/svg">
                <path className=' fill-black dark:fill-white'
                    d="M108.4 0h23v22.8h21.2V0h23v69h-23V46h-21v23h-23.2zM206 23h-20.3V0h63.7v23H229v46h-23zm53.5-23h24.1l14.8 24.3L313.2 0h24.1v69h-23V34.8l-16.1 24.8-16.1-24.8V69h-22.6zm89.2 0h23v46.2h32.6V69h-55.6z"
                    data-original="#000000"
                ></path>
                <path
                    fill="#ff4c1e"
                    d="M107.6 471l-33-370.4h362.8l-33 370.2L255.7 512"
                    data-original="#ff4c1e"
                ></path>
                <path
                    fill="#ff651e"
                    d="M256 480.5V131h148.3L376 447z"
                    data-original="#ff651e"
                ></path>
                <path
                    fill="#ebebeb"
                    d="M142 176.3h114l16.951 22.7L256 221.7h-64.2l4.2 46.5h60l16.951 23.549L256 313.5H154.4zm14.4 160H202l3.2 36.3 50.8 13.6 19.127 22.66L256 433.6l-93.2-26z"
                    data-original="#ebebeb"
                ></path>
                <path
                    fill="#fff"
                    d="M369.6 176.3H255.8v45.4h109.6zm-8.3 91.9H255.8v45.4h56l-5.3 59-50.7 13.6v47.2l93-25.8z"
                    data-original="#ffffff"
                ></path>
            </g>
        </svg> );
}
